import { time12 } from "@/lib/fmt";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { LifeBuoy } from "lucide-react";

export function ImpersonationBanner() {
  const { session, user } = useAuth();
  const imp = session?.impersonation;
  if (!imp) return null;
  const end = async () => { await api.post("/auth/impersonation/end").catch(() => {}); window.location.href = "/platform-admin"; };
  const until = time12(imp.expires_at);
  return (
    <div className="no-print sticky top-0 z-50 bg-[#9E2A2B] text-white text-sm px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1" data-testid="impersonation-banner">
      <LifeBuoy className="h-4 w-4 shrink-0" />
      <span className="font-semibold">86'd support session</span>
      <span className="opacity-90">Viewing as {user?.name} · by {imp.admin_name} · “{imp.reason}” · ends {until}</span>
      <button onClick={end} className="ml-auto h-8 px-3 rounded-full bg-white text-[#9E2A2B] text-xs font-semibold hover:bg-stone-100 transition-colors" data-testid="impersonation-end-btn">End session</button>
    </div>
  );
}
